import React from 'react';
export function Footer() {
  return <footer className="py-8 px-4 border-t border-gray-200 bg-white text-center text-gray-500 text-[11px] sm:text-sm" data-id="element-65">
      <div className="max-w-2xl mx-auto space-y-1.5" data-id="element-66">
        <p className="font-bold text-brand-charcoal" data-id="element-67">
          System Automation & SPS PRO 2026
        </p>
        <p data-id="element-68">🇨🇭 Das Komplettsystem für technische Ausbildung</p>
        <p data-id="element-69">Entwickelt in der Schweiz. Für die Schweizer Industrie.</p>
        <p data-id="element-70">© 2026 — Alle Rechte vorbehalten.</p>
      </div>
    </footer>;
}